import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 用户证书信息分页列表
export function getUserCerPager(req, page) {
  return request({
    url: apiConfig.userCertificate.api.pager.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      projectName: req.projectName,
      storageStatus: req.storageStatus,
      paperStatus: req.paperStatus,
      page: page.page,
      pageSize: page.pageSize,
      certificateCode: req.certificateCode,
      certificateLevel: req.certificateLevel,
      certificateType: req.certificateType,
      issuingDate: req.issuingDate,
      createDate: req.createDate,
      agentId: req.agentId,
      issuingStartDate: req.issuingStartDate,
      issuingEndDate: req.issuingEndDate
    }
  });
}
// 用户证书信息分页列表搜索功能
export function searchUserCerPager(req, page) {
  return request({
    url: apiConfig.userCertificate.api.searchPager.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      projectName: req.projectName,
      storageStatus: req.storageStatus,
      paperStatus: req.paperStatus,
      page: page.page,
      pageSize: page.pageSize,
      certificateCode: req.certificateCode,
      certificateLevel: req.certificateLevel,
      certificateType: req.certificateType,
      issuingStartDate: req.issuingStartDate,
      issuingEndDate: req.issuingEndDate,
      agentId: req.agentId
    }
  });
}
// 查看用户证书
export function viewCertificateImg(req) {
  return request({
    url: apiConfig.userCertificate.api.viewCertificateImg.url,
    method: "post",
    data: {
      realName: req.realname,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 查看电子证书信息
export function getDigitalCertificateList(req) {
  return request({
    url: apiConfig.userCertificate.api.getDigitalCertificateList.url,
    method: "post",
    data: {
      realName: req.realname,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 查看纸质证书信息
export function getPaperCertificateInfo(id) {
  return request({
    url: apiConfig.userCertificate.api.getPaperCertificateInfo.url,
    method: "get",
    params: {
      id: id
    }
  });
}
// 标记纸质证书购买状态
export function editPaperCertificateStatus(req) {
  return request({
    url: apiConfig.userCertificate.api.editPaperCertificateStatus.url,
    method: "post",
    data: {
      id: req.id,
      paperStatus: req.paperStatus
    }
  });
}
// 批量标记纸质证书购买状态
export function editPaperCertificateStatusBatch(req) {
  return request({
    url: apiConfig.userCertificate.api.editPaperCertificateStatusBatch.url,
    method: "post",
    data: {
      realName: req.realname,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 上传购买纸质证书用户
export function uploadPaperCertificateUser(req) {
  return request({
    url: apiConfig.userCertificate.api.uploadPaperCertificateUser.url,
    method: "post",
    data: {
      realName: req.realname,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 导出入库信息
export function exportUserCertificate(searchForm) {
  return request({
    url: apiConfig.userCertificate.api.exportUserCertificate.url,
    method: "post",
    data: searchForm,
    responseType: "blob"
  });
}
// 导出证书zip
export function exportZip(data) {
  return request({
    url: apiConfig.userCertificate.api.exportZip.url,
    method: "post",
    data: data,
    responseType: "blob"
  });
}

// 删除证书
export function deleteCertificate(data) {
  return request({
    url: apiConfig.userCertificate.api.delete.url,
    method: "post",
    data: data
  });
}
// 添加证书
export function addCertificate(req) {
  return request({
    url: apiConfig.userCertificate.api.add.url,
    method: "post",
    data: {
      userId: req.userId,
      certificateCode: req.certificateCode,
      project: req.project,
      certificateType: req.certificateType,
      certificateLevel: req.certificateLevel,
      issuingDate: req.issuingDate,
      certificateFile: req.certificateFile,
      cerDescription: req.cerDescription,
      description: req.description
    }
  });
}
// 更新证书
export function updateCertificate(req) {
  return request({
    url: apiConfig.userCertificate.api.update.url,
    method: "post",
    data: {
      id: req.id,
      userId: req.userId,
      certificateCode: req.certificateCode,
      project: req.project,
      certificateType: req.certificateType,
      certificateLevel: req.certificateLevel,
      issuingDate: req.issuingDate,
      certificateFile: req.certificateFile,
      cerDescription: req.cerDescription,
      description: req.description
    }
  });
}

// 查找证书
export function findCertificate(id) {
  return request({
    url: apiConfig.userCertificate.api.find.url,
    method: "get",
    params: {
      id: id
    }
  });
}

// 下载导入证书错误信息
export function exportUserCertificateError() {
  return request({
    url: apiConfig.userCertificate.api.importUserCertificate.url.exportError,
    method: "get",
    responseType: "blob"
  });
}
export function getCertificateCode(req) {
  return request({
    url: apiConfig.userCertificate.api.getCertificateCode.url,
    method: "post",
    data: req
  });
}
